import { render, staticRenderFns } from "./ListDiscussion.vue?vue&type=template&id=9e16d398"
import script from "./ListDiscussion.vue?vue&type=script&lang=js"
export * from "./ListDiscussion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports